import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warning\"><circle cx=\"8\" cy=\"8\" r=\"7.5\" /><path d=\"M7.21083 10.1884V11.75H8.78592V10.1884H7.21083ZM7.16504 4.25L7.25661 9.39726H8.74013L8.83171 4.25H7.16504Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol